import { startCase } from 'lodash';

import { COLUMN_NAME_MAPPING } from '../widgets/Table/columnHelpers/columnNameMapping';

export const getColumnLabel = (id: string) => COLUMN_NAME_MAPPING[id] || startCase(id);
